import { useQuery } from "@tanstack/react-query"

import { CategoryDto } from "@/api/api-client"
import { apiClient } from "@/api/client"

import type { ProductFormOption } from "./product-field-types"

function getCategoryOptions(
  categories: CategoryDto[],
  language: string,
  depth = 0
): ProductFormOption[] {
  return categories.flatMap((category) => [
    {
      label: "\u00A0".repeat(depth * 4) + (language === "es" ? category.nameEs : category.nameEn),
      value: category.id.toString(),
    },
    ...getCategoryOptions(category.subcategories || [], language, depth + 1),
  ])
}

export function useProductFormOptions(language: string) {
  const { data: categories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => apiClient.getCategoryTree(),
  })

  const { data: providers } = useQuery({
    queryKey: ["providers"],
    queryFn: () => apiClient.getAllProviders(),
  })

  const { data: warehouses } = useQuery({
    queryKey: ["warehouses"],
    queryFn: () => apiClient.getAllWarehouses(),
  })

  return {
    categoryOptions: categories ? getCategoryOptions(categories, language) : [],
    providerOptions:
      providers?.map((provider) => ({
        label: provider.name,
        value: provider.id.toString(),
      })) || [],
    warehouseOptions:
      warehouses?.map((warehouse) => ({
        label: warehouse.name,
        value: warehouse.id.toString(),
      })) || [],
  }
}
